import React from "react";
import styled from "styled-components";
import {
    useTable,
    usePagination,
    useRowSelect,
    useGlobalFilter,
    useAsyncDebounce,
    useSortBy
} from "react-table";
import GlobalFilter from "./GlobalFilter";
import Pagination from "./Pagination";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";

const Styles = styled.div`
    overflow-x: auto;
    table {
        border-spacing: 0;
        width: 100%;

        tr {
            &:not(:last-child) {
                border-bottom: 1px solid #ebedf3;
            }
            :last-child {
                td {
                    border-bottom: 0;
                }
            }
        }

        th {
            font-weight: 600;
            color: #b5b5c3 !important;
            font-size: 0.9rem;
            text-transform: uppercase;
            letter-spacing: 0.1rem;
            border-bottom: 1px solid #ebedf3;

            span {
                opacity: 0;
                transition: opacity 0.3s ease;
            }

            &:hover span {
                opacity: 1;
            }
        }

        th,
        td {
            margin: 0;
            vertical-align: middle !important;
            padding: 1rem;
            line-height: 1.5;

            :last-child {
                border-right: 0;
            }
        }
        td {
            vertical-align: top;
        }
    }

    .pagination {
        padding: 0.5rem;
    }
`;

export function ReactTable({ columns, data, loading, search }) {
    // Use the state and functions returned from useTable to build your UI
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        preGlobalFilteredRows,
        setGlobalFilter,
        state: { pageIndex, pageSize, globalFilter, selectedRowIds }
    } = useTable(
        {
            columns,
            data,
            initialState: {
                hiddenColumns: [ 'address']
            }
        },
        useGlobalFilter,
        useSortBy,
        usePagination,
        useRowSelect
    );

    // Render the UI for your table
    return (
        <>
            {!search && (
                <GlobalFilter
                    preGlobalFilteredRows={preGlobalFilteredRows}
                    globalFilter={globalFilter}
                    setGlobalFilter={setGlobalFilter}
                    useAsyncDebounce={useAsyncDebounce}
                />
            )}
            <Styles>
                <table {...getTableProps()}>
                    <thead>
                        {headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map(column => (
                                    <th
                                        {...column.getHeaderProps(
                                            column.getSortByToggleProps()
                                        )}
                                    >
                                    {column.Header || ''}
                                        <span>
                                            {column.isSorted ? (
                                                column.isSortedDesc ? (
                                                    <span className="svg-icon svg-icon-sm svg-icon-primary ml-1">
                                                        <SVG
                                                            title="Sort"
                                                            src={toAbsoluteUrl(
                                                                "/media/svg/icons/Navigation/Up-2.svg"
                                                            )}
                                                        />
                                                    </span>
                                                ) : (
                                                    <span className="svg-icon svg-icon-sm svg-icon-primary ml-1">
                                                        <SVG
                                                            title="Sort"
                                                            src={toAbsoluteUrl(
                                                                "/media/svg/icons/Navigation/Down-2.svg"
                                                            )}
                                                        />
                                                    </span>
                                                )
                                            ) : (
                                                <span className="svg-icon svg-icon-sm svg-icon-primary ml-1">
                                                    <SVG
                                                        title="Sort"
                                                        src={toAbsoluteUrl(
                                                            "/media/svg/icons/Shopping/Sort1.svg"
                                                        )}
                                                    />
                                                </span>
                                            )}
                                        </span>
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {loading && <tr className="m-5 spinner-border"></tr>}
                        {page.map((row, i) => {
                            prepareRow(row);
                            return (
                                <tr {...row.getRowProps()}>
                                    {row.cells.map(cell => {
                                        return (
                                            <td {...cell.getCellProps()}>
                                                {cell.render("Cell")}
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </Styles>

            <Pagination
                canPreviousPage={canPreviousPage}
                canNextPage={canNextPage}
                pageIndex={pageIndex}
                gotoPage={gotoPage}
                setPageSize={setPageSize}
                pageSize={pageSize}
                gotoPage={gotoPage}
                previousPage={previousPage}
                nextPage={nextPage}
                pageOptions={pageOptions}
                pageCount={pageCount}
            />
        </>
    );
}
